import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { formats } from "@/mocks/siteData";

const comparisonRows = [
  { name: "小说", length: "单章约 3000—4000 字", pace: "按章连载", scene: "安静阅读、慢慢品读", entry: "内容目录 · 小说" },
  { name: "短剧", length: "单集约 3—4 分钟", pace: "按集更新", scene: "通勤、午休等碎片时间", entry: "内容目录 · 短剧" },
  { name: "漫画", length: "单话约 36—46 格", pace: "按话整理", scene: "看图入门、视觉体验", entry: "内容目录 · 漫画" },
  { name: "视频", length: "单条约 3—9 分钟", pace: "按主题收录", scene: "快速回顾、了解主线", entry: "内容目录 · 视频" },
];

export default function Formats() {
  return (
    <section id="formats" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="四种形式"
            title="同一部作品，四种打开方式"
            description="小说、短剧、漫画、视频各有侧重。先看看它们分别适合什么场景，再决定从哪一种入门，会比盲目开追更省时间。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {formats.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="h-40 w-full">
                  <img src={item.image} alt={`${item.name}形式的示意配图`} className="h-full w-full object-top" />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${item.icon} text-lg`} />
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-semibold text-foreground-950">{item.name}</h3>
                      <p className="text-[11px] text-foreground-500">{item.carrier}</p>
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-700">{item.feature}</p>
                  <dl className="mt-4 space-y-2 border-t border-background-200 pt-4 text-xs">
                    <div className="flex gap-2">
                      <dt className="shrink-0 text-foreground-400">适合</dt>
                      <dd className="text-foreground-600">{item.audience}</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="shrink-0 text-foreground-400">建议</dt>
                      <dd className="text-foreground-600">{item.tip}</dd>
                    </div>
                  </dl>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">四种形式对比一览</h3>
                <p className="mt-1 text-sm text-foreground-600">从篇幅、更新节奏到适合场景，一张表看清差异。</p>
              </div>
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-table-2" />
                对比表
              </span>
            </div>

            <div className="mt-5 overflow-x-auto">
              <table className="w-full min-w-[640px] border-collapse text-left text-sm">
                <thead>
                  <tr className="border-b border-background-300 text-xs uppercase tracking-wide text-foreground-500">
                    <th className="py-3 pr-4 font-medium">形式</th>
                    <th className="py-3 pr-4 font-medium">单条篇幅 / 时长</th>
                    <th className="py-3 pr-4 font-medium">更新节奏</th>
                    <th className="py-3 pr-4 font-medium">适合场景</th>
                    <th className="py-3 font-medium">入口</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonRows.map((row) => (
                    <tr key={row.name} className="border-b border-background-200/70 last:border-b-0">
                      <td className="py-3 pr-4 font-medium text-foreground-900">{row.name}</td>
                      <td className="py-3 pr-4 text-foreground-600">{row.length}</td>
                      <td className="py-3 pr-4 text-foreground-600">{row.pace}</td>
                      <td className="py-3 pr-4 text-foreground-600">{row.scene}</td>
                      <td className="py-3">
                        <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">{row.entry}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}